import React from "react";
import moment from "moment";

import { getText } from "../helpers";

export default function ControlTranslationIdLabel(props) {
  const { translation, onClick } = props;

  if (!translation) return null;

  const translationIdLabel = `${getText("Translation ID")}: ${translation.id}`;
  const translationDate = translation.translation_result && moment(translation.translation_result.updated_at).format("DD MMM YYYY");

  return (
    <span>
      <a className="likified-link h5 translation-id" onClick={onClick}>{translationIdLabel}</a>
      &nbsp;
      <span className="translation-date h5">{translationDate}</span>
    </span>
  );
}



// WEBPACK FOOTER //
// ./src/components/control_translation_id_label.js